<!-- 解除停售数据操作 -->
<template>
  <div>
    <subComponents ref="showSelectData"></subComponents>
    <stopSellingTemplate ref="stopSellingTemplate"></stopSellingTemplate>

    <el-dialog :visible.sync="dataActionBox.showStatus" :title="dataActionBox.boxTitle" :close-on-click-modal="false" center append-to-body top="2rem" width="80%">
      <div>
        <el-form label-width="130px" size="mini">
          <el-row>
            <el-col :span="12" v-for="(formOneValue,formOneKey) in formDataList.jurconfigform" :key="formOneKey" v-if="formOneValue.isShow==1">
              <el-form-item :label="formOneValue.showField" :hide-required-asterisk="formOneValue.isRequired == 1 ? true : false">
                <!-- 系统字段 -->
                <div v-if="formOneValue.isReserved == 0">
                  <!-- 商品 -->
                  <el-input v-if="formOneValue.entityField == 'bgmId'" v-model.trim="sendDataInfo.bgmName" :maxlength="$store.state.inputLength" @focus="openSearch(formOneValue.searchId, 0, 'bgmId')">
                  </el-input>

                  <!-- 解除停售数量 -->
                  <el-input v-else-if="formOneValue.entityField == 'unstopAmount'" type="number" v-model.number="sendDataInfo[formOneValue.entityField]"></el-input>

                  <el-input v-else v-model.trim="sendDataInfo[formOneValue.entityField]" disabled :maxlength="$store.state.inputLength"></el-input>

                </div>
                <!-- 扩展字段 -->
                <div v-if="formOneValue.isReserved == 1">

                  <!-- 自填 -->
                  <el-input v-model.trim="sendDataInfo[formOneValue.entityField]" v-if="formOneValue.operatType == 0" :maxlength="$store.state.inputLength">

                  </el-input>
                  <!-- 选择数据来源 -->
                  <el-input v-model.trim="sendDataInfo[formOneValue.entityField]" v-else :maxlength="$store.state.inputLength" @focus="$refs['showSelectData'].openBox(formOneValue.dsmName,formOneValue.entityField,formOneValue.dsmField)">
                  </el-input>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dataActionBox.showStatus = false">取 消</el-button>
        <el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType==0">保存</el-button>
        <el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType==1">保存</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
      <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
  </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import stopSellingTemplate from "@/components/stopSellingTemplate.vue";
export default {
  name: "removeStopSellingAction",
  props: [],
  //import引入的组件需要注入到对象中才能使用
  components: {
    stopSellingTemplate
  },
  data() {
    //这里存放数据
    return {
      dataActionBox: {
        showStatus: false,
        boxTitle: "新增信息" || "编辑信息",
        actionType: 0, // 0新增，1修改
      },
      sendDataInfo: {
        bgmId: "",
        bgsId: "",
        bgmName: "",
        rsmReserves1: "",
        rsmReserves2: "",
        rsmReserves3: "",
        rsmReserves4: "",
        rsmReserves5: "",
        rsmReserves6: "",
        ssmId: "",
        unstopAmount: 0,
      },
      formDataList: {},
      DialogVisible: false,
      seTitle: "",
      seWidth: "",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    changeInputModel(val) {
      if (val != "" || val != undefined) {
          console.log(val)
        this.DialogVisible = false;

        if (this.seType == "bgmId") {
          this.sendDataInfo = val;
          this.sendDataInfo.spec = val.spec;
          this.sendDataInfo.bgmId = val.bgmId;
          this.sendDataInfo.bgmName = val.bgmName;
        //   this.sendDataInfo.sfiApayment = val.sfiApayment;
        }
      }
      // this.sendDataInfo.pisOrderDetail[this.seIndex].bgmName = val.bgmName
    },
    // 检索Id, 索引(表格中), 标识ppamId
    openSearch(sId, index, type) {
      this.DialogVisible = true;
      this.seId = sId;
      this.seIndex = index;
      this.seType = type;
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getWidth(e) {
      this.exWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },
    initActionBox() {
      for (let key in this.sendDataInfo) {
        this.sendDataInfo[key] = "";
      }

      this.sendDataInfo.unstopAmount = 0;

      this.dataActionBox.actionType = 0;
      this.dataActionBox.showStatus = false;
    },

    isShowData(name, value) {
      this.sendDataInfo[name] = value;
    },
    selectDataAction(dataInfo) {
      this.sendDataInfo = dataInfo;
    },

    async openBox(cate, formData, oldData) {
      this.formDataList = formData;
      this.initActionBox();
      if (cate == 0) {
        this.dataActionBox.boxTitle = "新增解除停售信息";
      } else {
        this.dataActionBox.boxTitle = "编辑解除停售信息";
        var dataInfo = JSON.parse(JSON.stringify(oldData));
        this.sendDataInfo = dataInfo;
      }
      this.dataActionBox.actionType = cate;
      this.dataActionBox.showStatus = true;
    },

    async sendDataAction() {
      if (this.sendDataInfo.bgmId == "") {
        this.$message({
          message: "请选择商品",
          type: "error",
        });
        return false;
      }
      let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
      if (this.dataActionBox.actionType == 0) {
        var responseData = await this.$http.addRemoveStopSelling(sendData);
      } else {
        var responseData = await this.$http.addRemoveStopSelling(sendData);
      }
      if (responseData.status == 200) {
        this.initActionBox();
        this.$message({
          message: "操作成功",
          type: "success",
        });
        if (this.dataActionBox.actionType == 0) {
          this.$parent.setDataPageNumber(1);
        } else {
          this.$parent.getDataList();
        }
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>